module.exports = __webpack_public_path__ + "834fa8f4c18bb701c244d1fcab666738.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/logo.png
// module id = 572
// module chunks = 0